export default [
    {
        path: 'relatorio-tempo-atendimento',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-tempo-atendimento' */
            '@/views/pronto-atendimento/relatorio-tempo-atendimento/Index'
        ),
        redirect: 'relatorio-tempo-atendimento/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-tempo-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-tempo-atendimento' */
                    '@/views/pronto-atendimento/relatorio-tempo-atendimento/List.vue'
                ),
            },
        ],
    },
]